import { DataPointsApiResponse } from '@tableau/metrics-engine';
import { SiteUrls } from '@tableau/shared-urls';

import { IDataRoleInfo } from '~src/dataRole/models/IDataRoleInfo';
import { IDataSourceInfo } from '~src/datasource/models/IDataSourceInfo';
import { FlowListItemInfo } from '~src/flow/models/FlowInfo';
import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { ILensInfo } from '~src/lens/models/ILensInfo';
import { IMetricInfo } from '~src/metrics/models/IMetricInfo';
import { IProjectInfo } from '~src/projects/models/IProjectInfo';
import { IPublishedConnectionInfo } from '~src/publishedConnection/models/IPublishedConnectionInfo';
import { IUserInfo } from '~src/userManagement/users/models/IUserInfo';
import { ItemCounts } from '~src/userManagement/users/serverApi/types/IUser';
import { IViewInfo } from '~src/views/models/IViewInfo';
import { IWorkbookInfo } from '~src/workbook/models/IWorkbookInfo';


export type NavigationItemValueType = OmniboxMenuItemType | MenuItemHeaderInfo | 'searchBox';

export type OmniboxMenuItemPlaceholder = { id: string, type: OmniBoxItemType };

export type OmniboxMenuItemType =
  IViewInfo
  | IWorkbookInfo
  | IMetricInfo
  | IDataSourceInfo
  | FlowListItemInfo
  | IProjectInfo
  | CatalogOmniboxItem
  | IUserInfoForOmni
  | IDataRoleInfo
  | ILensInfo
  | IPublishedConnectionInfoForOmni
  | OmniboxMenuItemPlaceholder;

export enum OmniBoxItemType {
  databases = 'databases',
  dataRoles = 'dataRoles',
  datasources = 'datasources',
  flows = 'flows',
  global = 'global',
  lenses = 'lenses',
  metrics = 'metrics',
  projects = 'projects',
  virtualConnections = 'virtualConnections',
  tables = 'tables',
  views = 'views',
  workbooks = 'workbooks',
  searchbox = 'searchBox',
  sectionHeader = 'sectionHeader',
  placeholder = 'placeholder',
  collections = 'collections',
  searchTermItem = 'searchTermItem',
  pastQueryItem = 'pastQueryItem',
  contentSuggestionItem = 'contentSuggestionItem',
  contentTypeItem = 'contentTypeItem',
  ownerItem = 'ownerItem'
}

export type NavigationItem = {
  sectionIndex: number;
  itemIndex: number;
  type: OmniBoxItemType;
  target: NavigationItemValueType;
  left: NavigationItemValueType | null;
  right: NavigationItemValueType | null;
  up: NavigationItemValueType | null;
  down: NavigationItemValueType | null;
  total: number;
  contentId?: string;
  countInSection: number;
  countInRow: number;
}

export interface MenuItemHeaderInfo {
  headerType: OmniBoxItemType;
}

export interface Section {
  type: OmniBoxItemType;
  list: ListResult<OmniboxMenuItemType>;
}

export interface IPublishedConnectionInfoForOmni extends IPublishedConnectionInfo {
  value?: string;
}

export interface IMetricInfoForOmni extends IMetricInfo {
  value?: string;
  response?: DataPointsApiResponse;
}

export interface IUserInfoForOmni extends IUserInfo {
  ownedItemCounts?: ItemCounts;
}

export interface CatalogOmniboxItem {
  readonly id: string;
  readonly name: string;
  readonly isCertified: boolean;
  readonly workbookCount: number;
  readonly datasourceCount: number;
}

export interface IQuickLinksContentTypes {
  name: string;
  getPath: (urls: SiteUrls) => string;
  icon: string;
}

export enum ContentType {
  view = 'view',
  metric = 'metric',
  workbook = 'workbook',
  unifieddatasource = 'unifieddatasource',
  virtualconnection = 'virtualconnection',
  flow = 'flow',
  project = 'project',
  table = 'table',
  database = 'database',
  datarole = 'datarole',
  lens = 'lens',
  collection = 'collection',
}

export type ContentSuggestionData = {
  hits: {
    items: ContentSuggestionDataItem[];
  };
};

export type ContentSuggestionDataItem = {
  content: {
    id: number;
    luid?: string;
    title?: string;
    type: string;
    ownerName?: string;
    hitsMediumSpanTotal?: number;
    graphQLId?: string;
    isCertified?: boolean;
    modifiedTime?: string;
    itemCount?: number;
    connectedWorkbooksCount?: number;
    path?: string;
  };
  highlights?: {
    title?: string[];
    owner?: string[];
  };
}